/**
 * Functions for fetching and managing event feedback
 */

/**
 * Fetch detailed feedback for a specific event
 * @param eventId The ID of the event to fetch feedback for
 * @param token Authentication token
 * @returns Promise with the feedback data
 */
export async function getEventFeedback(eventId: string, token: string) {
  const apiUrl = import.meta.env.VITE_CC_API_URL || "";
  
  const response = await fetch(`${apiUrl}/v1/feedback/event/${eventId}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch feedback: ${response.status}`);
  }
  
  return response.json();
}

/**
 * Fetch summarized feedback for a specific event
 * @param eventId The ID of the event to fetch feedback summary for
 * @param token Authentication token
 * @returns Promise with the summarized feedback data
 */
export async function getEventFeedbackSummary(eventId: string, token: string) {
  const apiUrl = import.meta.env.VITE_CC_API_URL || "";
  
  const response = await fetch(`${apiUrl}/v1/feedback/summary/event/${eventId}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch feedback summary: ${response.status}`);
  }
  
  return response.json();
}
